/**
 * True when the user has asked for reduced data use, through the browser's
 * data saver (saveData) or the prefers-reduced-data media feature.
 * Safe to call on the server, where it returns false.
 */
export default function prefersReducedData() {
  if (typeof window === 'undefined') return false;
  // @ts-ignore saveData is not in the TypeScript DOM types
  return Boolean(navigator.connection?.saveData) || window.matchMedia('(prefers-reduced-data: reduce)').matches;
}
